/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DateTime from 'react-datetime';
import moment from 'moment';
import { formatDateHyphen } from '../../utils/dateHelpers';
import { createDeployment } from '../../actions/deploymentActions';
import ShortNameField from '../Common/shortNameField';
import DescriptionField from '../Common/descriptionField';
// import ProductSelect from '../Common/productSelect';

class NewDeployment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      titleEdited: false,
      dateEmpty: false,
      productEmpty: false,
      deployment: {
        ...props.deployment,
        id: '',
        short_name: '',
        deployment_date: moment(),
        description: '',
        product_id: undefined
      }
    };
  }

  handleFieldChange = field => {
    let { deployment } = this.state;
    deployment = { ...deployment, ...field };
    this.setState({ deployment });
  };

  handleSave = event => {
    event.preventDefault();
    const { deployment } = this.state;
    this.setState({ titleEdited: true });

    if (!deployment.deployment_date) {
      this.setState({ dateEmpty: true });
      return;
    }
    if (!deployment.product_id) {
      this.setState({ productEmpty: true });
      return;
    }

    if (deployment.short_name || deployment.deployment_date) {
      this.props
        .createDeployment({ deployment })
        .then(() => this.props.onClose());
    }
  };

  handleDateChange = (date, type) => {
    this.setState(prevState => {
      const { deployment } = prevState;
      deployment[type] = formatDateHyphen(date);
      if (deployment.end_date < deployment.start_date)
        deployment.end_date = deployment.start_date;

      return { ...prevState.deployment, ...deployment };
    });
  };

  handleSelectChange = productId => {
    const { deployment } = this.state;
    deployment.product_id = Number(productId);
    this.setState({ deployment });
  };

  render() {
    if (!this.props.isOpen) {
      return null;
    }
    const { deployment, productEmpty } = this.state;

    return (
      <div className="detail-modal" tabIndex="-1" role="dialog">
        <div className="detail-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="col-sm-10">
                <h4 className="modal-title">Create New Deployment</h4>
              </div>
              <div className="col-sm-2 detail-close">
                <button
                  type="button"
                  className="close"
                  onClick={this.props.onClose}
                >
                  <span>&times;</span>
                </button>
              </div>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-sm-7">
                  <label htmlFor="short-name">
                    Name
                    <sup>*</sup>
                  </label>
                  <ShortNameField
                    shortName={deployment.short_name}
                    onNameChange={evt =>
                      this.handleFieldChange({ short_name: evt.target.value })
                    }
                    titleEdited={this.state.titleEdited}
                    allowEdit
                  />
                  <DescriptionField
                    id={deployment.id}
                    type="deployments"
                    description={deployment.description}
                    onFieldChange={this.handleFieldChange}
                    allowEdit
                  />
                </div>
                <div className="col-sm-4 col-sm-offset-1">
                  <div>
                    <label htmlFor="deployment_date">
                      Deployment Date
                      <sup>*</sup>
                    </label>
                    <DateTime
                      value={deployment.deployment_date}
                      dateFormat="YYYY-MM-DD"
                      timeFormat={false}
                      onChange={date =>
                        this.handleDateChange(date, 'deployment_date')
                      }
                      closeOnSelect
                    />
                  </div>
                  {this.state.dateEmpty && (
                    <div className="red">Please fill the date</div>
                  )}
                </div>
                <br />
                <div className="col-sm-4 col-sm-offset-1">
{/*                  <ProductSelect
                    fullWidth
                    onSelect={this.handleSelectChange}
                    selected={deployment.product_id}
                  />*/}
                  {productEmpty && (
                    <div className="red">Please select a product</div>
                  )}
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleSave}
              >
                Save
              </button>
              <button
                type="button"
                className="btn btn-default"
                onClick={this.props.onClose}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

NewDeployment.propTypes = {
  deployment: PropTypes.object,
  lastPlanned: PropTypes.object,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  createDeployment: PropTypes.func
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createDeployment
    },
    dispatch
  );

export default connect(
  null,
  mapDispatchToProps
)(NewDeployment);
